import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _extends from 'babel-runtime/helpers/extends';

import PreviewerInfo from './previewerInfo.vue';
import PreviewerSwitcher from './previewerSwitcher.vue';
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import { getVideoMetaData as _getVideoMetaData } from '@com/utils/video.js';
import getResponsiveBox from '@com/utils/get-responsive-box.js';
import PlayablePreviewer from '@pt/components/playablePreviewer.vue';
import qrcode from '@/components/Qrcode';
import { previewDmakerCustom } from '@/api/creative/custom';
import { previewGmakerProject } from '@pt/api/gmaker/project.js';
import _ from 'lodash';
import { language } from '@/common/storage';
import { isMultiGameDifficulty } from '@/views/creative/utils';
import { addQueryString } from '@com/utils/url';
import { mapState } from 'vuex';
import { mindworksInteractiveAdsUrl } from '@pt/config/host';
import ptTracker from '@pt/metrics-tracking/playturbo-collector';

export default {
  props: {
    info: {
      // { name: string, detail: array, tag: string, description: string }
      type: Object,
      default: null
    },

    currentId: {
      type: [Number, String],
      required: true
    },

    creatives: {
      type: Array,
      default: null
    },

    switcher: {
      type: Boolean,
      default: true
    },

    qrcode: {
      type: Boolean,
      default: true
    },

    previewLoading: {
      type: Boolean,
      default: false
    },

    projectType: [String], // normal: 普通制作预览 ; dco: dco 预览（现在PT前台已没有入口）; playsmart: 自由编辑器预览; mgroup: 多组合预览
    previewType: [String], // project: 项目预览； template: 模版预览（包含我的模版和可玩模板）
    pageType: [String], // myTemplate: 我的模板；index: 可玩模板; star: 我的收藏; history: 我的历史; custom: 定制项目（只有在多组合的时候会用到该组件）
    customId: [Number],
    sourceId: [Number],
    skinId: [Number]
  },

  components: {
    PreviewerInfo: PreviewerInfo,
    PreviewerSwitcher: PreviewerSwitcher,
    videoPlayer: videoPlayer,
    PlayablePreviewer: PlayablePreviewer,
    qrcode: qrcode
  },

  data: function data() {
    return {
      playerOptions: null,
      playablePreviewUrl: '',
      playableLoading: false
    };
  },


  computed: _extends({}, mapState({
    userInfo: function userInfo(state) {
      return state.user.info;
    }
  }), {
    currentCreative: function currentCreative() {
      var _this = this;

      return this.creatives.find(function (item) {
        return item.id === _this.innerCurrentId;
      }) || {};
    },
    innerCurrentId: function innerCurrentId() {
      return this.currentId;
    },
    isImage: function isImage() {
      return this.currentCreative.creative_type === 1;
    },
    isVideo: function isVideo() {
      return this.currentCreative.creative_type === 2;
    },

    // 多组合playable，todo 添加多组合判断条件
    isPlayable: function isPlayable() {
      return this.currentCreative.creative_type === 3;
    },
    innerCreatives: function innerCreatives() {
      var _this2 = this;

      var temp = _.cloneDeep(this.creatives);
      return temp.map(function (item) {
        var info = [];
        // 资源
        if (item.resource && item.resource.list) {
          item.resource.list.forEach(function (el) {
            info.push({
              label: el.prefix,
              name: el.name
            });
          });
        }
        // i18n
        if (item.i18n && item.i18n.list) {
          item.i18n.list.forEach(function (el) {
            info.push({
              label: el.prefix,
              name: el.name
            });
          });
        }
        // game_config
        if (item.game_config && item.game_config.list) {
          item.game_config.list.forEach(function (el) {
            // 多难度模式下，用户可能在不同的语言下新增了难度，导致其 name 混杂了中英文，所以这里重新获取一次 i18n 中的数据
            if (isMultiGameDifficulty(el.prefix)) {
              var tag = el.category_id.replace('GameDifficulty', '');
              info.push({
                label: el.prefix,
                name: _this2.$i18n.t('playTurbo.gamePlay.difficulty.' + tag + '.name')
              });
            } else {
              info.push({
                label: el.prefix,
                name: el.name
              });
            }
          });
        }
        if (_this2.isPlayable && (!_this2.projectType || _this2.projectType !== 'dco')) {
          return _extends({}, item, {
            tips: info
          });
        }
        return item;
      });
    },


    // 返回预览的场景，主要用于素材分析
    materialPreviewType: function materialPreviewType() {
      if (this.previewType === 'template' && this.pageType !== 'myTemplate') {
        return 'pt_template_index';
      } else if (this.previewType === 'template' && this.pageType === 'myTemplate') {
        return 'pt_template_self';
      } else if (this.previewType === 'project') {
        if (this.projectType === 'normal') {
          return 'pt_project_normal';
        } else if (this.projectType === 'playsmart') {
          return 'pt_project_ps';
        } else if (this.projectType === 'iv') {
          return 'pt_project_iv';
        }
      } else if (this.pageType === 'history') {
        return 'pt_project_export';
      } else if (this.pageType === 'custom') {
        return 'pt_project_custom';
      }
      return '';
    }
  }),

  watch: {
    'currentCreative.preview_url': function currentCreativePreview_url() {
      this.getVideoMetaData();
    },
    currentCreative: function currentCreative() {
      if (this.currentCreative.creative_type === 3) {
        this.getMutilPreviewUrl();
      }
    }
  },

  mounted: function mounted() {
    this.getVideoMetaData();
    this.getMutilPreviewUrl();
  },
  destroyed: function destroyed() {
    this.playerOptions = null;
  },


  methods: {
    cookPreviewUrl: function cookPreviewUrl(url, data) {
      if (!url) return '';
      var postData = data || {};
      var previewUrl = addQueryString(url, {
        loading: 1,
        preview: true,
        lang: language.get()
      });
      return addQueryString(mindworksInteractiveAdsUrl, _extends({
        url: previewUrl,
        mw_test: process.env.NODE_ENV === 'production' ? 0 : 1
      }, postData, {
        ptloading: 1, // 是否使用pt loading
        track_data: _JSON$stringify({
          pid: this.customId || this.sourceId,
          uid: this.userInfo.id,
          skin_id: this.skinId,
          sct: this.materialPreviewType,
          env: process.env.NODE_ENV === 'production' ? 'p' : 't',
          cc: this.userInfo.cc || -1
        })
      }));
    },
    handleChange: function handleChange(id) {
      this.$emit('update:currentId', id);
    },
    getMutilPreviewUrl: function getMutilPreviewUrl() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this3.currentCreative.preview_url && _this3.projectType !== 'playsmart' && _this3.projectType !== 'iv')) {
                  _context.next = 32;
                  break;
                }

                _this3.playableLoading = true;
                _context.prev = 2;
                res = void 0;

                if (!(_this3.previewType === 'project' && _this3.projectType === 'normal')) {
                  _context.next = 11;
                  break;
                }

                ptTracker.startEventById({
                  pid: _this3.customId,
                  uid: _this3.userInfo.id,
                  e: 'preview',
                  scene: 'pt',
                  sct: 'pt_project_normal'
                }, _this3.customId);
                _context.next = 8;
                return previewGmakerProject({
                  id: _this3.customId
                });

              case 8:
                res = _context.sent;
                _context.next = 23;
                break;

              case 11:
                if (!(_this3.previewType === 'project')) {
                  _context.next = 18;
                  break;
                }

                ptTracker.startEventById({
                  pid: _this3.customId,
                  uid: _this3.userInfo.id,
                  e: 'preview',
                  scene: 'pt',
                  sct: 'pt_project_group',
                  extra: {
                    group_name: _this3.currentCreative.name
                  }
                }, _this3.customId);
                _context.next = 15;
                return previewGmakerProject({
                  id: _this3.customId,
                  group_name: _this3.currentCreative.name
                });

              case 15:
                res = _context.sent;
                _context.next = 23;
                break;

              case 18:
                if (!(_this3.pageType !== 'myTemplate')) {
                  _context.next = 23;
                  break;
                }

                ptTracker.startEventById({
                  pid: _this3.customId,
                  uid: _this3.userInfo.id,
                  e: 'preview',
                  scene: 'pt',
                  sct: 'pt_project_custom_group',
                  extra: {
                    group_name: _this3.currentCreative.name
                  }
                }, _this3.customId);
                _context.next = 22;
                return previewDmakerCustom({
                  id: _this3.customId,
                  group_name: _this3.currentCreative.name
                });

              case 22:
                res = _context.sent;

              case 23:
                _this3.playablePreviewUrl = _.get(res, 'data.data.preview_url');
                _context.next = 29;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context['catch'](2);

                console.log(_context.t0);

              case 29:
                _this3.playableLoading = false;
                _context.next = 33;
                break;

              case 32:
                if (_this3.projectType === 'dco') {
                  _this3.playablePreviewUrl = _this3.currentCreative.preview_url + '?dco_gid=' + _this3.currentCreative.gid;
                } else {
                  _this3.playablePreviewUrl = _this3.currentCreative.preview_url;
                }

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[2, 26]]);
      }))();
    },
    getVideoMetaData: function getVideoMetaData() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var data, maxWidth, _getResponsiveBox, width, height;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.isVideo && _this4.currentCreative.preview_url)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 3;
                return _getVideoMetaData(_this4.currentCreative.preview_url);

              case 3:
                data = _context2.sent;
                maxWidth = _this4.$refs['previewer-inner'].clientWidth;
                _getResponsiveBox = getResponsiveBox({
                  maxWidth: maxWidth,
                  maxHeight: 426,
                  width: data.width,
                  height: data.height
                }), width = _getResponsiveBox.width, height = _getResponsiveBox.height;

                _this4.playerOptions = {
                  muted: true,
                  language: 'en',
                  // playbackRates: [0.7, 1.0, 1.5, 2.0],
                  height: height,
                  width: width,
                  sources: [{
                    type: 'video/mp4',
                    src: _this4.currentCreative.preview_url
                  }]
                };

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }
};